import { getCollaboratorInviteContext } from "@/services/public/collaboratorSessionService";

export function collaboratorAccessGuard(to, from, next) {
  const inviteContext = getCollaboratorInviteContext();

  if (!inviteContext?.invite_token) {
    next({ name: "login-comp" });
    return;
  }

  next();
}
